import type React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/** Redirect an old address to its new page, keeping the query (e.g. ?appId=) and setting fixed params. */
export default function RedirectKeepingQuery({ to, set }: { to: string; set?: Record<string, string> }) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  for (const [k, v] of Object.entries(set || {})) params.set(k, v);
  const q = params.toString();
  return <Navigate to={`${to}${q ? `?${q}` : ''}${location.hash}`} replace />;
}

/** An old ?tab= of a page that no longer exists: send it on before the page mounts (the page's own address
 *  sync would otherwise put its default tab back). */
export function RetiredTabRedirect({ tab, to, children }: { tab: string; to: string; children: React.ReactNode }) {
  const location = useLocation();
  if (new URLSearchParams(location.search).get('tab') === tab) return <Navigate to={to} replace />;
  return <>{children}</>;
}
